import React, {PropTypes} from 'react';
import './id_verification.less'
import DashBoardHeader from '../../header_dashboard/dashboard_header';
import ProfileNavBar from '../profile_navbar/profile_navbar';
import validate from '../../util/validate';
import {toTitleCase, join} from '../../util/common';
import ShowError from '../../components/error/show_error';
import authActions from '../../auth/auth_actions';
import profileActions from '../../profile/profile_actions';
import LogoutPopUp from '../../components/logoutPopUp/logout_pop_up';
import CONSTANTS from '../../common_constants';
import {Link, browserHistory} from 'react-router';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import LoggedinFooter from '../../footer/loggedin_footer';
import cookies from '../../util/cookie';
import SuccessMessage from '../../components/success/success_msg';
import UploadPhotoComponent from '../../image_upload/image_upload'

class IDVerificationDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageUrl : props.userData.userVerificationDocumentImageUrl || ""
    }
  }
  componentWillReceiveProps(newProps){
    if(newProps.userData.userVerificationDocumentImageUrl)
    {
      this.setState({
        imageUrl : newProps.userData.userVerificationDocumentImageUrl || ""
      })
    }
  }
  onImgUpload = (URL) =>{
    let data = {
      imageUrl : URL
    }
    this.props.authActions.idVerification(data).then(() => {

    },(errorRes) => {
        if(errorRes.error === CONSTANTS.sessionInvalid){
          this.setState({isLoading: false})
          this.props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        this.setState({isLoading: false,successMsg:""});
        this.setState({error: errorRes.error, validationError: validationError});
    })
    this.setState({
      imageUrl : URL
    })

  }
  render() {
    const imgURL = this.state.imageUrl;
    return (
      <div className = "id-verification-wrap">
        {this.state.error && <ShowError errorMessage={this.state.error}/>}
        <div className ="upload-shipment-photo-wrap">
          {this.state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
          <div className = "upload-shipment-photo">
            {
              !imgURL && <UploadPhotoComponent title = "Select your Verification Image"getImageUrlCallback = {this.onImgUpload}/>
            }
            {
              imgURL &&
              <div className = "selected-image-wrap">
                <div className = "heading">
                      Verify ID
                </div>
                <div className = "selected-img" style={{"backgroundImage": 'url("' + imgURL + '")'}}></div>
            </div>
            }
          </div>
        </div>
      </div>
    )
  }
}


class IDVerification extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {props, state} = this;
    const {userData} = props.authState;
    let sessionValid = true ;
    if("sessionValid" in props.authState.userData) sessionValid = props.authState.userData.sessionValid

    let user = {
        name: '',
        imageUrl: '',
        isVerified: '',
        creditAmount: ''
     };

    if(props.authState) {
      user.name = userData.name;
      user.imageUrl = userData.profileImageUrl;
      user.isVerified = userData.isVerified;
      user.creditAmount = userData.creditAmount
    }

    return (
      <div className="account-details-wrap account-section">
        <DashBoardHeader user={user} logout={this.logout}/>
        <LogoutPopUp isOpen={!sessionValid}></LogoutPopUp>
        <div className="account-header-wrap">
          <div className="wrapper">
            <h2 className="page-header account-page-header">Account</h2>
          </div>
        </div>
        <div className="wrapper account-wrapper">
          <div className="profile-nav-bar-component">
            <ProfileNavBar pathname={this.props.location.pathname} userData={user}/>
            </div>
            <div className="account-details-component">
              <IDVerificationDetails payment = {this.props.payment}paymentActions = {this.props.paymentActions}authActions ={props.authActions} userData={props.authState.userData} profileActions={props.profileActions}/>
            </div>
          </div>
          <LoggedinFooter />
      </div>
    )
  }
}

IDVerification = connect((state) => {
    return {
        authState: state.app.auth,
        profile: state.app.profile}
}, (dispatch) => {
    return {
        routerActions: bindActionCreators(routerActions, dispatch),
        authActions: bindActionCreators(authActions, dispatch),
        profileActions: bindActionCreators(profileActions, dispatch)
    }
})(IDVerification);

export default IDVerification;



// WEBPACK FOOTER //
// app/profile/id_verification/id_verification.jsx